import styled from 'styled-components';
import * as Bento from '@prezi/bento';
export const Link = styled(Bento.Link).withConfig({
  displayName: "Typography__Link",
  componentId: "yt23l-0"
})(["background-color:#f9fafb;padding:6px 8px;border-radius:8px;margin-inline-end:10px;border:1px solid #d2d6db;"]);
export const SingleLineLink = styled(Bento.Link).withConfig({
  displayName: "Typography__SingleLineLink",
  componentId: "yt23l-1"
})(["background-color:#f9fafb;padding:6px 8px;border-radius:8px;margin-inline-end:10px;border:1px solid #d2d6db;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
export const SmallLabel = styled.div.withConfig({
  displayName: "Typography__SmallLabel",
  componentId: "yt23l-2"
})(["font-family:", ";font-weight:", ";font-size:9px;line-height:11px;letter-spacing:0.17px;color:", ";"], ({
  theme
}) => theme.bento.font.primary.family, ({
  theme
}) => theme.bento.font.primary.weight.semibold, ({
  theme
}) => theme.bento.colors.text.weak);